import { defineStore } from 'pinia'

import api from '@/api/api'
import { StoreShowTime, parseShowTime } from '@/models'
import { byId, deleteById, gtmEvt, sortBy, upsertById } from '@/utils/utils'

import { ShowTimeRead, ShowTimeWrite } from '@generated/types'

export interface ShowTimesState {
  showtimes: StoreShowTime[]
}

export const useShowTimeStore = defineStore({
  id: 'showtime',
  state: (): ShowTimesState => {
    return {
      showtimes: [],
    }
  },
  getters: {
    showTimeById() {
      return (id: number) => this.showtimes.find(byId(id))
    },
  },
  actions: {
    storeShowTime(showtime: ShowTimeRead): StoreShowTime {
      return upsertById(parseShowTime(showtime), this.showtimes)
    },

    async fetchAll() {
      const response = await api.getShowTimes()
      response.data.map(this.storeShowTime)
      sortBy(this.showtimes, 'time24')
    },

    async addShowTime(newShowTime: ShowTimeWrite): Promise<StoreShowTime> {
      gtmEvt('addShowTime')
      const response = await api.addShowTime(newShowTime)
      const showtime = this.storeShowTime(response.data)
      sortBy(this.showtimes, 'time24')
      return showtime
    },

    async updateShowTime(existingShowTime: ShowTimeWrite) {
      gtmEvt('updateShowTime')
      const response = await api.updateShowTime(existingShowTime)
      const showtime = this.storeShowTime(response.data)
      sortBy(this.showtimes, 'time24')
      return showtime
    },

    async deleteShowTime(id: number) {
      gtmEvt('deleteShowTime')
      await api.deleteShowTime(id)
      deleteById(id, this.showtimes)
      return sortBy(this.showtimes, 'time24')
    },
  },
})
